module.exports = __webpack_public_path__ + "img/logs_divisions.ccdf0b64.png";